import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the DEX Exchanges API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const DEX_EXCHANGES_API_ENDPOINTS = {
  getExchanges: {
    generated: 'apiControllerGetExchanges',
    method: 'get',
    path: '/web/exchanges/:blockchainId',
  },
} as const satisfies Record<string, EndpointDef>;

export type DexExchangesEndpointName = keyof typeof DEX_EXCHANGES_API_ENDPOINTS;
